/**
 * Type guard: does `err` look like an axios HTTP 401 rejection?
 *
 * Used at every catch site that needs to distinguish "session expired,
 * apiClient interceptor already dispatched auth:session-expired, route is
 * about to unmount" from "real failure to render an empty/error UI for".
 * Mirrors the shape produced by axios when a request rejects with a 401
 * response (axios attaches `.response.status` to the error object).
 *
 * Extracted from useAuthStore.ts so non-store consumers (e.g.
 * WizardStepDateTime.vue's 401-suppression guard introduced in
 * quick-260528-ohn / PODZ-1704) can share a single source of truth.
 */
export function isUnauthorizedError(err: unknown): boolean {
  return (
    typeof err === 'object' &&
    err !== null &&
    'response' in err &&
    (err as { response?: { status?: number } }).response?.status === 401
  );
}
